export const LcConstants = {
  RO: 'isReadOnly',
  AT: 'account_access_token',
  RT: 'account_refresh_token',
  EXP: 'expires',
  IAT: 'impersonator_access_token',
  IRT: 'impersonator_refresh_token',
  IEXP: 'impersonator_expires',
  STUDENT_ID: 'impersonating_student_id',
  SECTION_ID: 'impersonating_section_id',
  EDUCATION_PERIOD: 'impersonator_education_period',
  ISUBJECT: 'impersonator_subject',
  ICURRENTSUBJECT: 'impersonator_current_subject',
  IS_WELCOME_VIDEO_FIRST_TIME: 'impersonator_is_welcome_video_first_time',
  STUDENT_NAME: 'impersonating_student_name',
  SECTION_NAME: 'impersonating_section_name',
  IMPERSONATOR_REDIRECT_SUBJECT_ID: 'impersonator_redirect_subject_id',
};
